<template>
    <div class="announcement">
        <div class="announcement-wrap">
            <div class="announcement-img">
                <img v-if="lan == 'ch'" src="../../assets/notice-ch.png" alt="">
                <img v-else src="../../assets/notice-en.png" alt="">
            </div>
            <div class="my-outbox">
                <!-- <div class="my-inbox" ref='box'>
                    <div class="my-list" v-for="(item,index) in dataList" :key='index' ref='list'>
                        <span class="my-uname">{{item.exh_name}}</span>
                    </div>
                </div> -->
                <!-- <div class='scroll_view_border'>
                  <div class="srcoll_view">
                    <span v-for="(item,index) in dataList" :key='index'>{{item.exh_name}}</span>
                  </div>
                </div> -->
                <div class="notice-card-wrapper">
                  <div class="header">
                    <div class="title">
                      <!-- 系统公告 -->
                      <div class="message" ref="inner_container">
                        <div  class="inner-container" :style="{marginLeft: startLeft + 'px'}">
                          <p ref="move_span" v-for="(item,index) in dataList" :key='index'>{{item.exh_name}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

  import Cookie from "../../common/cookie";
  export default {
    props: {
        dataList: {
            type: Array,
            default: () => []
        },
        datacount:{
          type: Number
        },
    },
    computed: {
    },
    data() {
      return {
        disArr: [],
        lan: Cookie.get("lang"),
        nowdatacount: (this.datacount / 1000).toFixed(),
        timer:null,
        startLeft: 0,
        moveLeft: 0,
        clientWidth: 0,
        animate:false,
      }
    },
    methods: {
      changeLeft(){
        // console.log(this.nowdatacount,'0000000')
        console.log(this.$refs.inner_container.clientWidth);
        this.startLeft = this.$refs.inner_container.clientWidth;
        var nowWidth=0;

        for(let i = 0; i < this.$refs.move_span.length; i++){
          nowWidth += this.$refs.move_span[i].clientWidth;
        }
        nowWidth = nowWidth + ((this.$refs.move_span.length - 1) * 40)
        this.moveLeft = nowWidth;
        this.timer = setInterval(()=>{
          this.startLeft--;
          if(this.startLeft <= -this.moveLeft){
            this.startLeft = this.$refs.inner_container.clientWidth;
          }
        }, this.nowdatacount)
      }
    },
  mounted () {
    this.changeLeft();

  },
  beforeDestroy(){
    clearInterval(this.timer);
  }
}


</script>

<style scoped>
    .announcement{
        width: 100%;
        /* background: #fff; */
    }
    .announcement-wrap{
        width: 1200px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex !important;
        display: -webkit-flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        margin: auto;
        position: relative;
    }
    .announcement-img{
        position: absolute;
        top: 50%;
        transform: translateY(-45%);
        width: 100px;
        padding-left: 10px;
    }
    .announcement .announcement-img img{
        width: 90px;
        display: inline-block;
    }
    .announcement-content span{
        margin-right: 50px;
    }

    .my-outbox{
        margin-left: 120px;
        overflow: hidden;
        color: #000000;
        height: 40px;
    }
    .my-inbox{
        white-space: nowrap;
    }

    .my-list{
      margin-right: 25px;
      display: inline-block;
      font-size: 0.3rem;
      height: 40px;
      line-height: 40px;
    }

    .my-uname{
    /*color: #FF8900;*/
    font-size: 1rem;
    color: #000000;
    }



    .srcoll_view{
      position: absolute;
      top:0px;
      height: 40px;
      font-size: 14px;
      white-space: nowrap;
      line-height: 40px;
      color: #000;
      animation:myfirst 20s linear infinite;
    }
    @keyframes myfirst{
        from {margin-left:750px;}
        to {margin-left:-1500px;}
    }


.notice-card-wrapper .inner-container {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    width: 100000%;
    /* animation: myMove 30s linear infinite;
    animation-fill-mode: forwards; */
  }
  .inner-container p{
    display: inline-block;
    margin-right: 40px;
  }
    /*文字无缝滚动*/
  /* @keyframes myMove {
    form {
        transform: translateX(0);
      }
    to {
        transform: translateX(-1400px);
      }
    }


    @-moz-keyframes mymove
    {
      form {
          transform: translateX(0);
        }
      to {
          transform: translateX(-1400px);
        }
    }

    @-webkit-keyframes mymove
    {
      form {
          transform: translateX(0);
        }
      to {
          transform: translateX(-1400px);
        }
    }

    @-o-keyframes mymove
    {
      form {
          transform: translateX(0);
        }
      to {
          transform: translateX(-1400px);
        }
    } */


</style>
